import React from 'react'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import dynamic from 'next/dynamic'

import styles from './styles.module.css'

const Page = dynamic(() => import('@page-components/Page'))

export default function EMenuDynamicPage(props) {
  const {emenuId} = props
  const websiteId = useWebsiteId()
  const {page} = useQuery({
    query: gql`
      query getWebsitePageEMenu_cached($websiteId: ID, $path: String) {
        page: websitePage(websiteId: $websiteId, path: $path) {
          _id
        }
      }
    `,
    variables: {
      websiteId,
      path: '/emenu/' + emenuId
    },
    partial: true
  })

  if (!page) return null
  return (
    <div className={styles.container}>
      <Page pageId={page._id} />
    </div>
  )
}
